import * as staticDataApi from '../redux/actionCreators/async/staticData';
import * as staticDataStore from '../redux/actionCreators/sync/staticData';
import * as labelDataApi from '../redux/actionCreators/async/labels';
import * as labelDataStore from '../redux/actionCreators/sync/labels';

export function loadStaticData(store) {
  return new Promise((resolve, reject) =>
      store.dispatch(
        staticDataApi.loadData({
          success(data) {
            store.dispatch(staticDataStore.updateStaticData(data));
            resolve();
          },
          error(err) {
            console.log(err);
            reject(err);
          }
        })
      )
    );
}

export function loadLabelData(store, accountId) {
  return new Promise((resolve, reject) =>
      store.dispatch(
        labelDataApi.loadData({
          success(data) {
            store.dispatch(labelDataStore.updateLabels(data));
            resolve();
          },
          error(err) {
            console.log(err);
            reject(err);
          }
        })
      )
    );
}



// WEBPACK FOOTER //
// ./shared/utils/loadStaticData.js